import styled from "styled-components";
import VisionBgPc from "@public/assets/main/vision-bg-pc.png"
import VisionText from "@public/assets/main/vision-text.png"
import VisionBgMo from "@public/assets/main/vision-bg-mo.png"
import {SIZES} from "@/components/constants";

const VisionSection = ({data}) => {
    return(
        <SectionWrap>
            <div className={"container"}>
                <img src={data["vision-pc-bg"]} className={"item01"} alt={"비전 비주얼 pc"}/>
                <img src={data["vision-text"]} className={"item02"} alt={"비전 내용"}/>
                <img src={data["vision-mo-bg"]} className={"item03"} alt={"비전 비주얼 mo"}/>
            </div>
        </SectionWrap>
    )
}
const SectionWrap = styled.section`
    padding: 120px 0;
    background-color: #f1f3f7;
    p{
        white-space: pre-line;
    }
    .container{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 80px;
        width: 100%;
        margin: 0 auto;
        padding: 0 20px;
        .item02{
            width: 722px;
        }
        .item03{
            display: none;
            width: 722px;
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
        }
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;
            
        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        .container {
            max-width: 1024px;
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;
        }
    }
    @media (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 80px 0;
        .container {
            gap: 3px;
            .item02{
                order: -1;
            }
        }
    }
    @media (max-width: ${SIZES.MOBILE_L}) {
        .container {

            .item01{
                display: none;
            }
            .item03{
                display: block;
                
            }
        }
    }
`
export default VisionSection;